import { useQuery, gql as graphql } from '@apollo/client';
import {
  programoptions,
  programoptionsVariables,
} from './_QueryTypes/programoptions';

const query = graphql`
  query programoptions($dbname: String!) {
    programoptions(dbname: $dbname)
  }
`;

export const useProgramoption = (
  option: string,
  dbname: string | null
): boolean | undefined => {
  const programOptions = useQuery<programoptions, programoptionsVariables>(
    query,
    {
      variables: { dbname: dbname ?? '' },
      skip: !dbname,
    }
  );
  return programOptions.data?.programoptions?.includes(option);
};
